module.exports = __webpack_public_path__ + "img/question_mark_FILL.c2b7cc67.svg";